import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ConstructionBarrierIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1 6.5C1 7.32843 1.67157 8 2.5 8H13.5C14.3284 8 15 7.32843 15 6.5V2.5C15 1.67157 14.3284 1 13.5 1H2.5C1.67157 1 1 1.67157 1 2.5V6.5ZM3.56089 2.5C3.63114 2.5 3.69625 2.53686 3.73239 2.5971L5.89239 6.1971C5.97237 6.33041 5.87635 6.5 5.72089 6.5H4.43808C4.36783 6.5 4.30273 6.46314 4.26658 6.4029L2.5285 3.50609C2.50985 3.47501 2.5 3.43944 2.5 3.4032V2.7C2.5 2.58954 2.58954 2.5 2.7 2.5H3.56089ZM9.72089 6.5C9.87635 6.5 9.97237 6.33041 9.89239 6.1971L7.73239 2.5971C7.69625 2.53686 7.63115 2.5 7.56089 2.5H6.27808C6.12262 2.5 6.0266 2.66959 6.10658 2.8029L8.26658 6.4029C8.30273 6.46314 8.36783 6.5 8.43808 6.5H9.72089ZM13.5 5.59851C13.5 5.56226 13.4901 5.5267 13.4715 5.49561L11.7324 2.5971C11.6962 2.53686 11.6311 2.5 11.5609 2.5H10.2781C10.1226 2.5 10.0266 2.66959 10.1066 2.8029L12.2666 6.4029C12.3027 6.46314 12.3678 6.5 12.4381 6.5H13.3C13.4105 6.5 13.5 6.41046 13.5 6.3V5.59851Z"
			></path>
			<path
				fill="currentColor"
				d="M4.5 9.5C4.5 9.22386 4.27614 9 4 9H3.5C3.22386 9 3 9.22386 3 9.5V13C3 13.2761 2.76274 13.4896 2.52051 13.6222C2.21034 13.792 2 14.1215 2 14.5C2 14.7761 2.22386 15 2.5 15H5C5.27614 15 5.5 14.7761 5.5 14.5C5.5 14.1215 5.28966 13.792 4.97949 13.6222C4.73726 13.4896 4.5 13.2761 4.5 13V9.5Z"
			></path>
			<path
				fill="currentColor"
				d="M13 9.5C13 9.22386 12.7761 9 12.5 9H12C11.7239 9 11.5 9.22386 11.5 9.5V13C11.5 13.2761 11.2627 13.4896 11.0205 13.6222C10.7103 13.792 10.5 14.1215 10.5 14.5C10.5 14.7761 10.7239 15 11 15H13.5C13.7761 15 14 14.7761 14 14.5C14 14.1215 13.7897 13.792 13.4795 13.6222C13.2373 13.4896 13 13.2761 13 13V9.5Z"
			></path>
		</svg>
	),
)
